// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDrop } from '../models/ApiDrop';
import { ApiNotificationCause } from '../models/ApiNotificationCause';
import { ApiProfileMin } from '../models/ApiProfileMin';
import { HttpFile } from '../http/http';

export class ApiNotification {
    'id': number;
    'cause': ApiNotificationCause;
    'created_at': number;
    'read_at': number | null;
    'related_identity': ApiProfileMin;
    'related_drops': Array<ApiDrop>;
    'additional_context': any;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "cause",
            "baseName": "cause",
            "type": "ApiNotificationCause",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "read_at",
            "baseName": "read_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "related_identity",
            "baseName": "related_identity",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "related_drops",
            "baseName": "related_drops",
            "type": "Array<ApiDrop>",
            "format": ""
        },
        {
            "name": "additional_context",
            "baseName": "additional_context",
            "type": "any",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiNotification.attributeTypeMap;
    }

    public constructor() {
    }
}


